import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'

import { ButtonPrimary } from '~/components/Buttons'
import { WindSurferProductStatAPI } from '~/statistics/types/wind-surfer.types'
import ROUTES from '~/shared/constants/routes.const'

import WindSerferActivitySummary from './WindSurferActivitySummary'
import RunDetails from './RunDetails'

interface Props {
  product: WindSurferProductStatAPI
}

export default function WindSurferDetails({ product }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const btnText = t('play')
  const router = useRouter()
  const isFamilyView = router.asPath.includes(ROUTES.FAMILY_ADMIN_PANEL)
  const { summary, details } = product
  const { bestLevel, bestScore, bestStreak } = summary

  const onClickContinueBtn = (): void => {
    statisticsAnalytics.logButtonClick(btnText)
  }

  return (
    <div>
      <WindSerferActivitySummary bestLevel={bestLevel} bestScore={bestScore} bestStreak={bestStreak} />
      <div className="relative">
        {details.length ? <p className="text-left font-semibold my-3 mx-3">{t('windSurfer.last-five')}</p> : <></>}
        {details.map((runDetails, key) => {
          const { bestStreak: streak, level, score } = runDetails
          return (
            <RunDetails bestStreak={streak} key={`details-${key}`} level={level} run={String(key + 1)} score={score} />
          )
        })}
        {!isFamilyView && (
          <ButtonPrimary
            className="ml-auto mt-4 px-4"
            href={ROUTES.WINDSURFER}
            noPadding
            onClick={onClickContinueBtn}
            size="medium"
          >
            {btnText}
          </ButtonPrimary>
        )}
      </div>
    </div>
  )
}
